import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; //  Importante para enviar solicitudes al backend
import { API_URL } from '../config';
import RankingPopup from '../components/RankingPopup';
import './PantallaInicio.css';

const PantallaInicio = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');

  const [mostrarRanking, setMostrarRanking] = useState(false);
  
  const iniciarSesion = async () => {
    if (!usuario || !contrasena) {
      alert('Por favor completa ambos campos');
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/validar-login`, {
        nombreUsuario: usuario,
        contrasena: contrasena
      });

      if (response.data.ok) {
        localStorage.setItem('usuario', usuario); // Acá se guarda el nombre de usuario
        navigate('/bienvenida?next=/pantallatutorial'); // Redirige si login es correcto
      } else {
        if (response.data.error === "usuario_no_existe") {
          alert("Usuario no registrado. Regístrate para jugar.");
        } else if (response.data.error === "contrasena_incorrecta") {
          if (window.confirm("Contraseña incorrecta. ¿Quieres recuperar tu contraseña?")) {
            navigate('/recuperar-password');
          }
        } else {
          alert("Error desconocido.");
        }
      }
    } catch (error) {
      console.error("Error al validar login:", error);
      alert("Ocurrió un error al conectar con el servidor.");
    }
  };

  return (
    <div className="pantalla-inicio">
      <div className="contenedor-login">
        <input
          type="text"
          placeholder="Nombre de usuario"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
        />
        <button className="btn-verde" onClick={iniciarSesion}>Iniciar sesión</button>
        
        <p className="registro">
          ¿No tienes cuenta? <span onClick={() => navigate('/registro')}>Regístrate aquí</span>
        </p>

        <button className="btn-ver-ranking" onClick={() => setMostrarRanking(true)}>📊 Ver Ranking</button>
        <RankingPopup visible={mostrarRanking} onClose={() => setMostrarRanking(false)} />    
      </div>

      {/* Incorporacion de contacto*/}
        <div className="footer-contacto">
          ¿Problemas durante tu turno?{" "}
          <a href="mailto:jolivos@udec.cl" className="footer-contacto-mail">
            Contacto: jolivos@udec.cl
          </a>
        </div>
    </div>
  );
};

export default PantallaInicio;
